module.exports = {"id":"226289","name":"Uche Agbo","rating":"72","photo":"./data/images/photos/4/226289.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["MDC","MC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/UcheAgbo0.json
// module id = 4204
// module chunks = 0